import { z } from 'zod';
import { DispositionFormDataSchema } from '@/modules/disposition/DispositionConfigurationPanel.tsx';

export type ScopeUnionParams = {
    errorMessages?: { required?: string };
};

export function getScopeUnion(params?: ScopeUnionParams) {
    const { errorMessages } = params ?? {};

    return z.discriminatedUnion('scope', [
        z.object({
            scope: z.literal('POSITION'),
        }),
        z.object({
            scope: z.literal('ORDER'),
            transportNumber: z.number().positive(),
            disposition: z.discriminatedUnion(
                DispositionFormDataSchema.discriminator,
                DispositionFormDataSchema.options,
                { message: errorMessages?.required }
            ),
        }),
    ]);
}
